import {createSlice} from '@reduxjs/toolkit'

export const attendeeSectionSlice = createSlice({
  name: 'attendeeSection',
  initialState: {
    attendeesList: [],
    totalCount: 0,
    searchTerm: '',
    defaultHeaders: [],
    allHeaders: [],
    selectedRowIds: []
  },
  reducers: {
    setAttendeesList: (state, action) => {
      state.attendeesList = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload
    },
    setDefaultHeaders: (state, action) => {
      state.defaultHeaders = action.payload
    },
    setAllHeaders: (state, action) => {
      state.allHeaders = action.payload
    },
    setSelectedRowIds: (state, action) => {
      state.selectedRowIds = action.payload
    }
  }
})

export const {setAttendeesList, setTotalCount, setSearchTerm, setDefaultHeaders, setAllHeaders, setSelectedRowIds} =
  attendeeSectionSlice.actions

export default attendeeSectionSlice.reducer
